import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';
// import debounce from 'debounce';

function getCurrentRotation(el) {
    var st = window.getComputedStyle(el, null);
    var tm = st.getPropertyValue("-webkit-transform") ||
        st.getPropertyValue("-moz-transform") ||
        st.getPropertyValue("-ms-transform") ||
        st.getPropertyValue("-o-transform") ||
        st.getPropertyValue("transform") ||
        "none";
    if (tm != "none") {
        var values = tm.split('(')[1].split(')')[0].split(',');
        /*
        a = values[0];
        b = values[1];
        angle = Math.round(Math.atan2(b,a) * (180/Math.PI));
        */
        //return Math.round(Math.atan2(values[1],values[0]) * (180/Math.PI)); //this would return negative values the OP doesn't wants so it got commented and the next lines of code added
        var angle = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));
        return (angle < 0 ? angle + 360 : angle); //adding 360 degrees here when angle < 0 is equivalent to adding (2 * Math.PI) radians before
    }
    return 0;
}


const DefaultConfig = {
    loop: false,
    autoplay: false,
    //autoplayTimeout: 4000,
    //autoplayHoverPause: true,
    //autoplayButtonOutput: false,
    controls: false,
    nav: false,
    preventActionWhenRunning: true,
};
const CustomConfig = {
    intro: {
        items: 1,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        autoplayButtonOutput: false
    },
    cards: {
        items: 1,
        slideBy: 1,
        autoplayHoverPause: true,
        controls: true,
        controlsPosition: 'bottom',
        controlsText:
        [
            '<span class="icon icon--arrow icon--arrow--left"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 26 26"><path d="M13,0,10.637,2.364l8.948,8.948H0v3.377H19.585l-8.948,8.948L13,26,26,13Z"/></svg></span>',
            '<span class="icon icon--arrow icon--arrow--right"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 26 26"><path d="M13,0,10.637,2.364l8.948,8.948H0v3.377H19.585l-8.948,8.948L13,26,26,13Z"/></svg></span>'
        ],
        gutter: 15,
        responsive: {
            768: {
                items: 'auto',
                gutter: 36,
                fixedWidth: window.innerWidth/2,
                center: true
            },
            1023: {
                items: 3,
                fixedWidth: false,
                center: false,
                gutter: 60,
            }
        }
    },
    news: {
        items: 3,
        slideBy: 1,
        autoplayHoverPause: true,
        controls: true,
        controlsPosition: 'bottom',
        controlsText:
        [
            '<span class="icon icon--arrow icon--arrow--left"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 26 26"><path d="M13,0,10.637,2.364l8.948,8.948H0v3.377H19.585l-8.948,8.948L13,26,26,13Z"/></svg></span>',
            '<span class="icon icon--arrow icon--arrow--right"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 26 26"><path d="M13,0,10.637,2.364l8.948,8.948H0v3.377H19.585l-8.948,8.948L13,26,26,13Z"/></svg></span>'
        ],
        gutter: 40
    },
    gallery: {
        loop: false,
        autoplay: false,
        autoHeight: true,
        gutter: 1,
        items:1,
        arrowKeys: false,
        controls: false,
        lazyload: true

    },
    galleryThumbs: {
        loop: false,
        items: 3,
        autoplay: false,
        controls: true,
        controlsPosition: 'bottom',
        controlsText:
        [
            '<span class="icon icon--arrow icon--arrow--left"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 26 26"><path d="M13,0,10.637,2.364l8.948,8.948H0v3.377H19.585l-8.948,8.948L13,26,26,13Z"/></svg></span>',
            '<span class="icon icon--arrow icon--arrow--right"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 26 26"><path d="M13,0,10.637,2.364l8.948,8.948H0v3.377H19.585l-8.948,8.948L13,26,26,13Z"/></svg></span>'
        ],
        gutter: 15,
        responsive: {
            1024: {
                gutter: 60,
            }
        },
        mouseDrag: true,
        lazyload: true,
    },
};



const Callbacks = {
    gallery: (slider) => {
        let thumbsSlider = slider.closest('[data-gallery]').querySelector('[data-gallery-thumbs]');
        //slider.tns.events.on('indexChanged', (info) => {
        //    thumbsSlider.tns.goTo(info.displayIndex);
        //});

    },
    galleryThumbs: (slider) => {
        let gallerySlider = slider.closest('[data-gallery]').querySelector('[data-gallery-slider]');
        slider.tns.events.on('indexChanged', (info) => {
            slider.closest('[data-gallery]').setAttribute('data-gallery-open', '');
            gallerySlider.tns.goTo(info.displayIndex);
        });

        Array.from((slider.tns.getInfo()).slideItems).forEach((thumb) => {
            thumb.addEventListener('click', (event) => {
                slider.closest('[data-gallery]').setAttribute('data-gallery-open', '');
                gallerySlider.tns.goTo(thumb.getAttribute('data-gallery-thumb'));
            });
        })

    },
    intro: (slider) => {
        let rotated = document.querySelector('[data-js-rotated]');
        rotated.addEventListener('transitionend', () => {
            rotated.classList.remove('section__rotated--transition');
        })
        slider.tns.events.on('indexChanged', (info) => {
            if (document.querySelector('.slider-page__current')) {
                document.querySelector('.slider-page__current').innerText = parseInt(info.displayIndex);
            }
        });
        slider.tns.events.on('indexChanged', (info) => {

            rotated.classList.add('section__rotated--transition');
            if (info.indexCached < info.index) {
                rotated.style.transform = `rotate(-${getCurrentRotation(rotated)+180}deg)`;
            } else {
                rotated.style.transform = `rotate(${getCurrentRotation(rotated)-180}deg)`;
            }
        });

        let cachedPageYOffset = 0;
        window.addEventListener("scroll", () => {
            let scrollDirection = cachedPageYOffset <= window.pageYOffset ? 1 : -1;
            let scrollDistance = window.pageYOffset - cachedPageYOffset;
            rotated.style.transform = `rotate(${getCurrentRotation(rotated) + scrollDistance/2}deg)`;
            cachedPageYOffset = window.pageYOffset;
        });

    }
}
export function initSliders() {

    let sliders = document.querySelectorAll('[data-tns]');

    if (!sliders) {
        return false;
    }
    Array.from(sliders).forEach((slider) => {

        const type = slider.getAttribute('data-tns');
        const userConfig = JSON.parse(slider.getAttribute('data-tns-config')) || {};
        if (type === "gallery" && slider.nextElementSibling.classList.contains('gallery__thumbs')) {
            userConfig.navContainer = slider.nextElementSibling;
        }
        slider.tns = tns(Object.assign(DefaultConfig, CustomConfig[type] || {}, userConfig, { container: slider }));

        if (Callbacks[type]) {
            (Callbacks[type])(slider);
        }
    });
}

export default initSliders;
